import React from "react";
import BlogFaqList from "./BlogFaqList";

const BlogFaq = ({ faqBlogs }) => {
  return (
    <>
      <div className="sectiontitle">
        <div className="titleunderline" data-aos="fade-right">
          <svg
            width="64"
            height="3"
            viewBox="0 0 64 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 1.5H62"
              stroke="#F68633"
              stroke-width="3"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <h1>FAQ's</h1>
      </div>

      <div class="accordion accordion-flush" id="accordionFlushExample">
        {faqBlogs.map((faq, index) => (
          <BlogFaqList
            key={index}
            faqId={faq.id}
            question={faq.question}
            answer={faq.answer}
          />
        ))}
      </div>
    </>
  );
};

export default BlogFaq;
